// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { COLORS } from 'Components/utils/color/colors';

import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

export type ProductFeatureDetailFacilityProps = {
  className?: string,
  description?: string,
  id?: string,
  items?: Array<{
    description: string,
    label?: string,
  }>,
  quantity?: number,
  title: string,
};

export function ProductFeatureDetailFacility(props: ProductFeatureDetailFacilityProps) {
  const { className, id, items = [], description, quantity, title } = props;

  if (!title) {
    return null;
  }

  return (
    <article className={className} id={id}>
      <Title className="mb-0" hLevel={5} theme="title-sans-1">
        {title}
        {!!quantity && `: ${quantity}`}
      </Title>
      <Text className="m-0" color={COLORS.GRAY_DARKER} text={description} theme="text-sans-2" />
      {!isEmpty(items) && (
        <ul className="font-sans list-none p-0 mt-2 text-gray-darker text-sm">
          {items.map(item => {
            return (
              !!item.description && (
                <li className="list-disc" key={item.description}>
                  {item.label && <span className="font-bold">{item.label}: </span>}
                  {item.description}
                </li>
              )
            );
          })}
        </ul>
      )}
    </article>
  );
}
